import * as React from 'react';

type IconColors = 'light' | 'grey';
interface Props {
  color?: IconColors;
}

const colors: Record<IconColors, string> = {
  light: '#FFFFFF',
  grey: '#989898',
};

const TimeIcon: React.FC<Props> = ({ color = colors['light'] }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none">
    <g fill={color} fillRule="evenodd" clipRule="evenodd">
      <path d="M10.5 4.39c-3.512 0-6.62 3.127-6.62 6.606 0 3.478 3.108 6.507 6.62 6.507 3.511 0 6.68-3.029 6.68-6.507 0-3.479-3.169-6.607-6.68-6.607ZM2.82 10.995c0-4.22 3.442-7.633 7.678-7.633 4.237 0 7.679 3.413 7.679 7.633 0 4.22-3.442 7.633-7.679 7.633-4.236 0-7.678-3.413-7.678-7.633Z" />
      <path d="M10.5 7.345c.367 0 .518.297.518.663v2.616h1.487c.366 0 .708.133.708.5 0 .366-.342.535-.708.535H10.5c-.366 0-.521-.297-.521-.664V8.008c0-.366.155-.663.522-.663ZM6.028 1.646a.664.664 0 0 1-.15.927L3.124 4.564a.664.664 0 0 1-.778-1.076l2.756-1.991a.664.664 0 0 1 .927.15ZM14.973 1.646a.664.664 0 0 1 .926-.15l2.756 1.992a.664.664 0 1 1-.778 1.076l-2.755-1.991a.664.664 0 0 1-.15-.927Z" />
    </g>
  </svg>
);
export default React.memo(TimeIcon);
